module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-short-7ac57743.svg";